module.exports = __webpack_public_path__ + "media/the_moon_chasers.60381209.mp3";